import React, {useState, useEffect} from "react";
import '../../assets/css/sideBar.css';
import info_icon from '../../assets/images/info.svg';
import settings_icon from '../../assets/images/settings.svg';
import SideBarInfo from "../infoview/SideBarInfo";
import TextInputClearable from "../widget/TextInputClearable";
import dataset_specific_data from "../../data/Data";
import StandardDropdown from "../widget/StandardDropdown";
import InfoDetail from "../infoview/InfoDetail";
import logo_white from '../../assets/images/logo/chronos_HVIT_logo_CMYK.svg';
import VerticalMenu from "../widget/VerticalMenu";
import axios from 'axios';
import Swal from 'sweetalert2';

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const SideBar = ({ isOpen, get_data, method, coll_id, n_components, setGroupingLabel, metadata, data_length, numHighlighted }) => {
  const groups = Object.keys(metadata["toggleAttributes"])
  const toggleAttributes = Object.keys(metadata["toggleAttributes"])
  const [coloredLabelState, setColoredLabelState] = useState(groups[0]);
  const [collection, setCollection] = useState(null);
  const sidebarClass = isOpen ? "sidebar open" : "sidebar";
  const key_width = "150px"
  const labels = groups.map(item => ({id: item, val: capitalizeFirstLetter(item)}))
  labels.push({id: "cluster", val: "Cluster"})
  const default_label = dataset_specific_data["partition_vectors"]["default_label"]

  const [algorithmState, setAlgorithmState] = useState("-1")
  const algorithms = [
    {id: "kmeans", val: "K-means"},
    {id: "dbscan", val: "DBSCAN"},
    {id: "birch", val: "BIRCH"},
    {id: "agglomerative", val: "Agglomerative Clustering"},
    {id: "optics", val: "OPTICS"},
    {id: "gaussian_mixture", val: "Gaussian Mixture Model"},
  ]

  function getInputFieldDetails(element) {
    const inputs = element.querySelectorAll('[id*="_content"]');

    const inputDetailsDict = {};
    inputs.forEach(detail_content => {
      if (detail_content && detail_content.firstChild) {
        const content_inner = detail_content.firstChild
        if (content_inner.tagName === 'INPUT') {
          var value = content_inner.value
        } else {
          var value = content_inner.innerHTML
        }
        inputDetailsDict[detail_content.id.replace("_content", "")] = value
      }
    });

    return inputDetailsDict;
  }

  const get_cluster_algorithm = () => {
    var cluster_algorithm = document.getElementById("dropdown_cluster")
    if (cluster_algorithm) {
      return cluster_algorithm.getAttribute("data-selected")
    } else {
      return "-1"
    }
  }

  const get_cluster_config = () => {
    var cluster_config = document.getElementById("cluster_config") 
    if (cluster_config) {
      return getInputFieldDetails(cluster_config)
    } else {
      return "-1"
    }
  }

  const get_collection_by_id = (id) => {
    let params = {
        id: id,
    };

    console.log(params)

    axios.get('/api/get_collection', { params })
    .then(response => {
        setCollection(response.data["val"].replace("collection", ""));
    })
    .catch(error => {
        console.error('There was an error when fetching collection by id!', error);

        let msg = error.response.data.error
        Swal.fire({
            icon: 'error',
            title: 'Error!.',
            text: msg,
        });
    })
    .finally(() => {
    });
  }

  const filter_data = (entries_per_class="-1") => {
    if (entries_per_class != "-1") {
      entries_per_class = document.getElementById("entries_per_class_input").value;
      entries_per_class = entries_per_class === "" ? "-1" : entries_per_class;
    }
    let _groupingLabel = document.getElementById("dropdown_label").getAttribute("data-selected");
    let cluster_algorithm = get_cluster_algorithm();
    let cluster_config = get_cluster_config();
    let hiddenToggleAttributes = {}
    toggleAttributes.forEach((toggleAttribute) => {
      let pre_str = "checkbox-" + toggleAttribute + "-"
      let search_query = '[id*="' + pre_str + '"]';
      let checkboxes = document.querySelectorAll(search_query);
      let uncheckedBoxes = Array.from(checkboxes)
      .filter(checkbox => !checkbox.checked)
      .map(checkbox => checkbox.id.replace(pre_str, ""));
      hiddenToggleAttributes[toggleAttribute] = uncheckedBoxes
  });

    get_data(entries_per_class, _groupingLabel=_groupingLabel, cluster_algorithm=cluster_algorithm, cluster_config=cluster_config, hiddenToggleAttributes=hiddenToggleAttributes);
  }

  const get_all_data = () => {
    filter_data("-1")
  }

  const toggleColoredLabelState = (event) => {
    setColoredLabelState(event.target.id)
  }

  const toggleAlgorithmState = (event) => {
    setAlgorithmState(event.target.id)
  }

  const contains_n_clusters = (algorithm) => {
    return (algorithm === "kmeans" || algorithm === "birch" || algorithm === "agglomerative" || algorithm === "gaussian_mixture")
  }

  const contains_min_samples = (algorithm) => {
    return (algorithm === "dbscan" || algorithm === "optics")
  }

  useEffect(() => {
    get_collection_by_id(coll_id);
  }, []);
  
  return (
    <div className={sidebarClass}>
      <div className="space-between-vertical">
        <div className="flex-column" style={{height: "100vh"}}>
        <div id="sidebar-upper-seperator"></div>
        <section className="flex-column sidebar-content">
            <div className="flex-column" style={{gap: "12px"}}>
                <div className="flex-row centered-vertical" style={{gap: "13px"}}>
                    <img src={info_icon}/>
                    <h2 className="light no-margin">Info</h2>
                </div>
                <div className="flex-column" style={{gap: "8px"}}>
                  <SideBarInfo info_key="Method" value={method} key_width={key_width}/>
                  <SideBarInfo info_key="Collection" value={collection} key_width={key_width}/>
                  <SideBarInfo info_key="Dimensions" value={n_components} key_width={key_width}/>
                  <SideBarInfo info_key="Displayed points" value={data_length} key_width={key_width}/>
                  <SideBarInfo info_key="Highlighted" value={numHighlighted} key_width={key_width}/>
                </div>
            </div>
           
            <div className="flex-column" style={{gap: "34px"}}>
                <div className="flex-column" style={{gap: "12px"}}>
                    <div className="flex-row centered-vertical" style={{gap: "13px"}}>
                        <img src={settings_icon}/>
                        <h2 className="light no-margin">Configure</h2>
                    </div>
                    <form className="flex-column" style={{gap: "8px"}}>
                      <VerticalMenu title="Hide attributes" items={metadata["toggleAttributes"]}/>

                      <span className="font-medium semibold light">Entries per class</span>
                      <TextInputClearable id="entries_per_class" placeholder="Write a number.." clear_function={get_all_data}/>
                      <span className="font-medium semibold light">Colored label</span>
                      <StandardDropdown id="dropdown_label" text={capitalizeFirstLetter(default_label)} options={labels} white={true} onClick={toggleColoredLabelState} default_selected={default_label}/>
                       {(coloredLabelState === "cluster") ?
                      <> <span className="font-medium semibold light">Configure clustering</span>
                      <StandardDropdown id="dropdown_cluster" text={"Select an algorithm.."} options={algorithms} white={true} onClick={toggleAlgorithmState}/>
                      <div id="cluster_config" className="flex-column" style={{gap: "8px"}}>
                      {(contains_n_clusters(algorithmState)) ? 
                      <InfoDetail 
                      id="number_of_clusters" 
                      title="Number of clusters" 
                      default_value={5}  
                      info="represents the predefined number of groups into which the data points will be partitioned." 
                      />
                      : ""}
                      {(algorithmState == "dbscan") ? 
                      <InfoDetail 
                      id="epsilon" 
                      title="Epsilon" 
                      default_value={0.5}  
                      info="the maximum radius of the neighborhood around a point that is used to determine the density-based clustering." 
                      />
                      : ""}
                      {(contains_min_samples(algorithmState)) ? 
                      <InfoDetail 
                      id="min_samples" 
                      title="Minimum number of samples" 
                      default_value={5}  
                      info="the threshold specifying the minimum number of points required to form a dense region or cluster." 
                      />
                      : ""}
                      {(algorithmState == "optics") ? 
                      <InfoDetail 
                      id="xi" 
                      title="xi" 
                      default_value={0.05}  
                      info="controls the steepness required for a point to be considered a new cluster boundary. Smaller values result in more sensitive cluster detection." 
                      />
                      : ""}
                      {(algorithmState == "optics") ? 
                      <InfoDetail 
                      id="min_cluster_size" 
                      title="Minimum cluster size" 
                      default_value={0.1}  
                      info="sets the minimum number of points required for a group of points to be considered a valid cluster. This helps filter out noise and very small clusters." 
                      />
                      : ""}
                      </div>
                      </>: ""}
                    </form>
                </div>
                <div role="button" className="standard-button" onClick={filter_data}>
                    <span className="font-large light centered" >Update</span>
                </div>
            </div>
        </section>
        <div id="sidebar-lower-seperator"></div>
        </div>
        <img id="sidebar-logo" src={logo_white} alt="White chronos-logo" />
        </div>
    </div>
  );
};
export default SideBar;